"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardInfoRequest = void 0;
var CardInfoRequest = /** @class */ (function () {
    function CardInfoRequest() {
    }
    return CardInfoRequest;
}());
exports.CardInfoRequest = CardInfoRequest;
;
//# sourceMappingURL=cardInfo.request.js.map